import script from "./LoadingComponentVecino.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingComponentVecino.vue?vue&type=script&setup=true&lang=js"

import "./LoadingComponentVecino.vue?vue&type=style&index=0&id=7df41472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df41472"]])

export default __exports__